export const CHECKOUT_URL =
  'https://girlsflagfootballcoachsystem.impultienda.ar/checkout'

export const IMAGES = {
  bundle:
    'https://cdn.magicpatterns.com/uploads/m215fG2UseHfFpHDVxWX4H/ChatGPT_Image_9_sept_2026,_00_11_01.png',
}

export type SamplePage = {
  src: string
  category: string
  title: string
  alt: string
}

export const samplePages: SamplePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/73d7HgJPf7FLcC914bTDiW/02_SD-015_Quick-Read-Quick-Release.jpg',
    category: 'Skill drill',
    title: 'SD-015 — Quick Read, Quick Release',
    alt: 'Sample skill drill page SD-015 Quick Read, Quick Release, with goal, cues, field diagram, setup and progression steps.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/v4QYkCiptZySXEco5oAqVt/03_OD-09_Mesh-Route.jpg',
    category: 'Playbook concept',
    title: 'OD-09 — Mesh Route',
    alt: 'Sample playbook page OD-09 Mesh Route, with a field diagram, QB reads and when to use the concept.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7qeqdUmXkqNfuzJG1VyL8v/04_OD-10_Flood-Route.jpg',
    category: 'Playbook concept',
    title: 'OD-10 — Flood Route',
    alt: 'Sample playbook page OD-10 Flood Route, showing three receivers flooding one side with QB read progression.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ftC6ByZUkbf5fL93qXARw7/05_RP-05_First-Offensive-Concept-Practice.jpg',
    category: 'Ready-to-run practice',
    title: 'RP-05 — First Offensive Concept Practice',
    alt: 'Sample ready-to-run practice page RP-05, a 75 minute session plan with a timed block-by-block schedule and key teaching points.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nQ3L2RRCNbcRSGK6prkMMF/06_RP-10_Coverage-Development.jpg',
    category: 'Ready-to-run practice',
    title: 'RP-10 — Coverage Development',
    alt: 'Sample ready-to-run practice page RP-10 Coverage Development, with a timed practice schedule and a five-player zone positioning diagram.',
  },
]

export type Stage = {
  label: string
  description: string
}

export const stages: Stage[] = [
  {
    label: 'Open',
    description:
      'Open the system and go straight to the volume you need for today.',
  },
  {
    label: 'Choose',
    description:
      'Choose a written drill, a play concept or a complete ready-to-run practice.',
  },
  {
    label: 'Coach',
    description:
      'Run the session with a clear plan, then repeat it next practice without starting over.',
  },
]

export type Volume = {
  number: number
  stage: string
  title: string
  benefit: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    stage: 'Foundations',
    title: 'Girls Flag Foundations™',
    benefit:
      'Understand the game, build the team, establish standards and create a strong Girls Flag Football environment.',
  },
  {
    number: 2,
    stage: 'Skill development',
    title: 'Skill Development System™',
    benefit:
      '50 written skill drills and progressions covering the essential technical skills of Girls Flag Football.',
  },
  {
    number: 3,
    stage: 'Strategy',
    title: 'Offense & Defense Playbook™',
    benefit:
      'Offensive and defensive concepts, formations, reads and tactical systems you can understand and apply with your team.',
  },
  {
    number: 4,
    stage: 'Practice planning',
    title: 'Practice Builder System™',
    benefit:
      'A structured methodology for building organized, purposeful practices without improvising every session.',
  },
  {
    number: 5,
    stage: 'Season & game day',
    title: 'Season & Game-Day System™',
    benefit:
      'Organize the season, prepare for competition and make smarter game-day coaching decisions.',
  },
  {
    number: 6,
    stage: 'Ready to run',
    title: 'Ready-To-Run Practice Library™',
    benefit:
      '36 complete written practices so you can open the system, choose a session and coach.',
  },
]

export type Bonus = {
  number: number
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The Confident Coach Scriptbook™',
    description:
      'Written language for teaching, correcting and leading players with calm authority.',
  },
  {
    number: 2,
    title: 'Parent Communication Copy Vault™',
    description:
      'Ready-to-use written messages for updates, expectations and season communication.',
  },
  {
    number: 3,
    title: 'First-Time Girls Flag Coach Survival Guide™',
    description:
      'A practical starting point for your first season, from first practice to final game.',
  },
  {
    number: 4,
    title: 'Girls Flag Football Plain-English Glossary™',
    description:
      'Every term, position and concept explained in plain language you can teach from.',
  },
  {
    number: 5,
    title: 'Team Culture Codebook™',
    description:
      'Standards, routines and habits that build a team players want to show up for.',
  },
]

export const builtToHelp: string[] = [
  'Spend less time planning practices from a blank page',
  'Keep drills, plays and practices organized in one system',
  'Move from skill work to game strategy with a clearer structure',
  'Run more consistent, purposeful sessions all season',
]

export const offerIncludes: string[] = [
  '6 Professional Coaching Volumes',
  '5 Practical Bonus Resources',
  '50 Written Skill Drills',
  '36 Ready-To-Run Practices',
  'OPEN → CHOOSE → COACH framework',
  'Instant Digital Access',
  'One-Time Payment',
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is Girls Flag Football Coach System™ a physical product?',
    answer:
      'No. Girls Flag Football Coach System™ is a 100% digital, written coaching system. Nothing is shipped physically.',
  },
  {
    question: 'Is this a course?',
    answer:
      'No. This is not a course or training program. It is one complete written coaching system built for reference and day-to-day practice organization.',
  },
  {
    question: 'Is this software or an app?',
    answer:
      'No. There is nothing to install and no subscription. Everything is delivered digitally as written material you open and use.',
  },
  {
    question: 'Is it suitable for first-time Girls Flag Football coaches?',
    answer:
      'Yes. The structure is especially useful when you want a clear starting point for building the team, teaching skills and planning organized practices.',
  },
  {
    question: 'Can experienced coaches use it?',
    answer:
      'Yes. It is also built for experienced coaches who want to stop hunting for random drills and keep their skill work, plays and practices in one organized system.',
  },
  {
    question: 'Does it work for different age groups?',
    answer:
      'Yes. The drills, progressions and practice structures are written so you can adjust the demand and complexity to the age and experience level you coach.',
  },
  {
    question: 'Does it work for both 5v5 and 7v7 formats?',
    answer:
      'Yes. The skill work, concepts and practice structures apply across common formats. Formats, rushing, eligibility, contact and QB running rules vary between leagues, so always follow your specific league or organization rules.',
  },
  {
    question: 'Are the 50 drills videos?',
    answer:
      'No. All 50 drills are written drills and progressions, with the setup, coaching points and progression explained in text. There are no videos.',
  },
  {
    question: 'Are the 36 practices already written and ready to use?',
    answer:
      'Yes. All 36 practices are complete and already written. You open the system, choose a session and coach it.',
  },
  {
    question: 'Does this replace a coach’s judgment or league rules?',
    answer:
      'No. Girls Flag Football Coach System™ is a coaching reference and organization system. It does not replace your judgment, player safety decisions, or the rules of your specific league or organization, which always take priority.',
  },
  {
    question: 'How do I receive it?',
    answer: 'You receive instant digital access after completing your purchase.',
  },
]
